import React, { useEffect, useState } from 'react';
import { Table, Space, Select } from 'antd';
import { TableWrapper } from 'components/molecules';
import { ColumnsType } from 'antd/lib/table/interface';
import { FileExcelOutlined } from '@ant-design/icons';
import { Button } from 'components/atoms'
import * as XLSX from 'xlsx';

interface FormItemProps {
  salesList: any[] | undefined;  
  hiddenColumns: string[];  
  actPage: string;
  year: string;
  startMonth: string;  
  endMonth: string;
  detailCode: string;
  months: any[] | undefined;
  onChangeDetailMonth: (start:string, end:string) => void;  
}

const SALESTable = ({salesList, hiddenColumns, months, actPage, year, startMonth, endMonth, detailCode, onChangeDetailMonth}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [viewColumns, setViewColumns] = useState<any[]>([]);
  const [mergeCnt, setMergeCnt] = useState<number>(0);

  const sharedOnCell = (record) => {
    if (record.type === 'total') {
      return { colSpan: 0 };
    }
    return {};
  };

  const columns: ColumnsType<any> = [
    {
      title: '강의날짜',
      dataIndex: 'schedule_date',
      key: 'schedule_date',
      width: '100px',
      align: 'center',    
      ellipsis: true,
      onCell: (record) => ({
        colSpan: record.type === 'total' ? mergeCnt : 1,
      }),
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value}</label>
          ):(
            <label>{value}</label>
          )
        )
      }        
    },      
    {
      title: '강사',
      dataIndex: 'lecturer_name',
      key: 'lecturer_name',
      width: '100px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },  
    {
      title: '기업명',
      dataIndex: 'company_name',
      key: 'company_name',
      width: '150px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },   
    {
      title: '프로젝트명',
      dataIndex: 'title',
      key: 'title',
      width: 'auto',
      align: 'center', 
      ellipsis: true,   
      onCell: sharedOnCell,
    },
    {
      title: '강의구분',
      dataIndex: 'lecture_type1',
      key: 'lecture_type1',
      width: '130px',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },        
    {
      title: '강의주제',
      dataIndex: 'lecture_subject1',
      key: 'lecture_subject1',
      width: 'auto',
      align: 'center',
      ellipsis: true,
      onCell: sharedOnCell,
    },      
    {
      title: '강의시간',
      dataIndex: 'time_count',
      key: 'time_count',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value}</label>
          ):(
            <label>{value}</label>
          )
        )
      }      
    }, 
    {
      title: '강사매출',
      dataIndex: 'lecturer_price',
      key: 'lecturer_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },      
    {
      title: '교재비',
      dataIndex: 'teaching_price',
      key: 'teaching_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },    
    {
      title: '교통비',
      dataIndex: 'traffic_price',
      key: 'traffic_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },       
    {
      title: '설계비',
      dataIndex: 'plan_price',
      key: 'plan_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },    
    {
      title: '운영비',
      dataIndex: 'operating_price',
      key: 'operating_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },   
    {
      title: 'HSG진단',
      dataIndex: 'diagnose_price',
      key: 'diagnose_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },   
    {
      title: 'HSG컨설팅',
      dataIndex: 'consulting_price',
      key: 'consulting_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },    
    {
      title: '스튜디오비',
      dataIndex: 'studio_price',
      key: 'studio_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },   
    {
      title: '기타비',
      dataIndex: 'etc_price',
      key: 'etc_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },    
    {
      title: '누계',
      dataIndex: 'order_price',
      key: 'order_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },     
    {
      title: '매출',
      dataIndex: 'max_price',
      key: 'max_price',
      width: '120px',
      align: 'right',
      render: (value, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          ):(
            <label>{value? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0'}</label>
          )
        )
      }
    },                     
    {
      title: '5점',
      dataIndex: 'class5',
      key: 'class5',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }     
    },  
    {
      title: '7점',
      dataIndex: 'class7',
      key: 'class7',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }      
    },  
    {
      title: '10점',
      dataIndex: 'class10',
      key: 'class10',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }      
    },  
    {
      title: 'NPS',
      dataIndex: 'nps',
      key: 'nps',
      width: '80px',
      align: 'center',
      ellipsis: true,
      render: (evaluation, record) => {
        return (
          (record.type==='total')?(
            <label style={{fontWeight:'500',color:'blue'}}>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          ):(
            <label>{(evaluation > 0)? evaluation.toFixed(2) : ''}</label>
          )
        )
      }      
    },   
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onExcelDownload = () => {
    const header: string[] = [];
    const datas: any[] = [];
    const merges: any[] = [];

    if ("time" === actPage.toString()) {
      header.push('강의날짜');
      header.push('강사');
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('강의구분');
      header.push('강의주제');
      header.push('강의시간');
      header.push('5점');
      header.push('7점');
      header.push('10점');
      header.push('NPS');
    } else {
      header.push('강의날짜');
      switch(detailCode) {
        case '100001': 
        case '100002': 
        case '100003': 
        case '100004': 
        case '100005': 
        case '100006': 
        case '100007': 
        case '100008': 
        case '199999':
        {
          break;
        }
        default : {
          header.push('강사');
          break;          
        }        
      }      
      header.push('기업명');
      header.push('프로젝트이름');
      header.push('강의구분');
      header.push('강의주제');
      switch(detailCode) {
        case '100001': {
          header.push('교재비');
          break;
        }
        case '100002': {
          header.push('교통비');
          break;
        }
        case '100003': {
          header.push('설계비');
          break;
        }
        case '100004': {
          header.push('운영비');
          break;
        }
        case '100005': {
          header.push('HSG진단');                  
          break;
        }
        case '100006': {
          header.push('HSG컨설팅');
          break;
        }
        case '100007': {
          header.push('스튜디오비');                
          break;
        }
        case '100008': {
          header.push('기타비');        
          break;
        }
        case '199999': {
          header.push('교재비');
          header.push('교통비');
          header.push('설계비');
          header.push('운영비');
          header.push('HSG진단');
          header.push('HSG컨설팅');
          header.push('스튜디오비');
          header.push('기타비');
          header.push('누계');
          break;
        }   
        case '300000': {
          header.push('강의시간');
          header.push('강사매출');
          header.push('교재비');
          header.push('교통비');
          header.push('설계비');
          header.push('운영비');
          header.push('HSG진단');
          header.push('HSG컨설팅');
          header.push('스튜디오비');
          header.push('기타비');
          header.push('매출');
          break;
        }                                                                       
        default : {
          header.push('강의시간');
          header.push('강사매출');
          break;          
        }
      } 
    }

    let tot_sales = 0;
    let tot_sales01 = 0;
    let tot_sales02 = 0;
    let tot_sales03 = 0;
    let tot_sales04 = 0;
    let tot_sales05 = 0;
    let tot_sales06 = 0;
    let tot_sales07 = 0;
    let tot_sales08 = 0;
    let tot_sales09 = 0;
    let tot_sales10 = 0;
    let tot_time = 0;    
    let totalnps = 0;
    let totalclass5 = 0;
    let totalclass7 = 0;
    let totalclass10 = 0;
    let totalnpsCnt = 0;
    let totalclass5Cnt = 0;
    let totalclass7Cnt = 0;
    let totalclass10Cnt = 0;

    salesList?.forEach((item, index) => {
      if (item.type === 'info') {
        if ("time" === actPage.toString()) {
          const newItem = {
            '강의날짜': item.schedule_date,            
            '강사': item.lecturer_name,
            '기업명': item.company_name,
            '프로젝트이름': item.title,
            '강의구분': item.lecture_type1,
            '강의주제': item.lecture_subject1,
            '강의시간': item.time_count,
            '5점': item.class5>0?Number(item.class5.toFixed(2)):'',
            '7점': item.class7>0?Number(item.class7.toFixed(2)):'',
            '10점': item.class10>0?Number(item.class10.toFixed(2)):'',
            'NPS': item.nps>0?Number(item.nps.toFixed(2)):'',
          }
          datas.push(newItem);
        } else {
          const newItem = {
            '강의날짜': item.schedule_date,
            '기업명': item.company_name,
            '프로젝트이름': item.title,
            '강의구분': item.lecture_type1,
            '강의주제': item.lecture_subject1,
          }
          switch(detailCode) {
            case '100001': {
              datas.push({
                ...newItem,
                '교재비': item.teaching_price,   
              });  
              break;
            }
            case '100002': {
              datas.push({
                ...newItem,
                '교통비': item.traffic_price,   
              });  
              break;
            }
            case '100003': {
              datas.push({
                ...newItem,
                '설계비': item.plan_price,   
              });  
              break;
            }
            case '100004': {
              datas.push({
                ...newItem,
                '운영비': item.operating_price,   
              });  
              break;
            }
            case '100005': {
              datas.push({
                ...newItem,
                'HSG진단': item.diagnose_price,   
              });                   
              break;
            }
            case '100006': {
              datas.push({
                ...newItem,
                'HSG컨설팅': item.consulting_price,   
              });  
              break;
            }
            case '100007': {
              datas.push({
                ...newItem,
                '스튜디오비': item.studio_price,   
              });              
              break;
            }
            case '100008': {
              datas.push({
                ...newItem,
                '기타비': item.etc_price,   
              });       
              break;
            }
            case '199999': {
              datas.push({
                ...newItem,
                '교재비': item.teaching_price,   
                '교통비': item.traffic_price,   
                '설계비': item.plan_price,   
                '운영비': item.operating_price,   
                'HSG진단': item.diagnose_price,   
                'HSG컨설팅': item.consulting_price,   
                '스튜디오비': item.studio_price,   
                '기타비': item.etc_price,   
                '누계': item.order_price,   
              });  
              break;
            }   
            case '300000': {
              datas.push({
                ...newItem,
                '강사': item.lecturer_name,                
                '강의시간': item.time_count,
                '강사매출': item.lecturer_price,
                '교재비': item.teaching_price,   
                '교통비': item.traffic_price,   
                '설계비': item.plan_price,   
                '운영비': item.operating_price,   
                'HSG진단': item.diagnose_price,   
                'HSG컨설팅': item.consulting_price,   
                '스튜디오비': item.studio_price,   
                '기타비': item.etc_price,   
                '매출': item.max_price,   
              });              
              break;
            }                                                                       
            default : {
              datas.push({
                ...newItem,
                '강사': item.lecturer_name,                
                '강의시간': item.time_count,
                '강사매출': item.lecturer_price,                
              });              
              break;          
            }
          }          
        }
                
        tot_sales += item.lecturer_price?item.lecturer_price:0;
        tot_sales01 += item.teaching_price?item.teaching_price:0;
        tot_sales02 += item.traffic_price?item.traffic_price:0;
        tot_sales03 += item.plan_price?item.plan_price:0;
        tot_sales04 += item.operating_price?item.operating_price:0;
        tot_sales05 += item.diagnose_price?item.diagnose_price:0;
        tot_sales06 += item.consulting_price?item.consulting_price:0;
        tot_sales07 += item.studio_price?item.studio_price:0;
        tot_sales08 += item.etc_price?item.etc_price:0;
        tot_sales09 += item.order_price?item.order_price:0;
        tot_sales10 += item.max_price?item.max_price:0;
        tot_time += item.time_count?item.time_count:0; 
        if (item.nps > 0) {
          totalnps += item.nps;
          totalnpsCnt++;
        }
        if (item.class5 > 0) {
          totalclass5 += item.class5;
          totalclass5Cnt++;
        }
        if (item.class7 > 0) {
          totalclass7 += item.class7;
          totalclass7Cnt++;
        }
        if (item.class10 > 0) {
          totalclass10 += item.class10;
          totalclass10Cnt++;
        }                 
      } else {
        if ("time" === actPage.toString()) {
          const newItem = {
            '강사': item.lecturer_name,
            '5점': item.class5>0?Number(item.class5.toFixed(2)):'',
            '7점': item.class7>0?Number(item.class7.toFixed(2)):'',
            '10점': item.class10>0?Number(item.class10.toFixed(2)):'',
            'NPS': item.nps>0?Number(item.nps.toFixed(2)):'', 
            '강의시간': item.time_count,
          }
          datas.push(newItem);
        } else {
          const newItem = {
            '강의날짜': item.lecturer_name,
          }
          switch(detailCode) {
            case '100001': {
              datas.push({
                ...newItem,
                '교재비': item.teaching_price,   
              });  
              break;
            }
            case '100002': {
              datas.push({
                ...newItem,
                '교통비': item.traffic_price,   
              });  
              break;
            }
            case '100003': {
              datas.push({
                ...newItem,
                '설계비': item.plan_price,   
              });  
              break;
            }
            case '100004': {
              datas.push({
                ...newItem,
                '운영비': item.operating_price,   
              });  
              break;
            }
            case '100005': {
              datas.push({
                ...newItem,
                'HSG진단': item.diagnose_price,   
              });                   
              break;
            }
            case '100006': {
              datas.push({
                ...newItem,
                'HSG컨설팅': item.consulting_price,   
              });  
              break;
            }
            case '100007': {
              datas.push({
                ...newItem,
                '스튜디오비': item.studio_price,   
              });              
              break;
            }
            case '100008': {
              datas.push({
                ...newItem,
                '기타비': item.etc_price,   
              });       
              break;
            }
            case '199999': {
              datas.push({
                ...newItem,
                '교재비': item.teaching_price,   
                '교통비': item.traffic_price,   
                '설계비': item.plan_price,   
                '운영비': item.operating_price,   
                'HSG진단': item.diagnose_price,   
                'HSG컨설팅': item.consulting_price,   
                '스튜디오비': item.studio_price,   
                '기타비': item.etc_price,   
                '누계': item.order_price,   
              });  
              break;
            }   
            case '300000': {
              datas.push({
                ...newItem,
                '강의시간': item.time_count,
                '강사매출': item.lecturer_price,
                '교재비': item.teaching_price,   
                '교통비': item.traffic_price,   
                '설계비': item.plan_price,   
                '운영비': item.operating_price,   
                'HSG진단': item.diagnose_price,   
                'HSG컨설팅': item.consulting_price,   
                '스튜디오비': item.studio_price,   
                '기타비': item.etc_price,   
                '매출': item.max_price,   
              });              
              break;
            }                                                                       
            default : {
              datas.push({
                ...newItem,
                '강의시간': item.time_count,
                '강사매출': item.lecturer_price,                
              });              
              break;          
            }
          }          
        }
        merges.push({s: {c:0, r:index+1}, e: {c:mergeCnt-1, r:index+1}});
      }
    });
    if ("time" === actPage.toString()) {
      const newItem = {
        '강사': '합계',
        '5점': (totalclass5Cnt>0)?Number((totalclass5/totalclass5Cnt).toFixed(2)):'',
        '7점': (totalclass7Cnt>0)?Number((totalclass7/totalclass7Cnt).toFixed(2)):'',
        '10점': (totalclass10Cnt>0)?Number((totalclass10/totalclass10Cnt).toFixed(2)):'',
        'NPS': (totalnpsCnt>0)?Number((totalnps/totalnpsCnt).toFixed(2)):'',      
        '강의시간': tot_time,
      }
      datas.push(newItem);
    } else {
      const newItem = {
        '강의날짜': '합계',
      }
      switch(detailCode) {
        case '100001': {
          datas.push({
            ...newItem,
            '교재비': tot_sales01,   
          });  
          break;
        }
        case '100002': {
          datas.push({
            ...newItem,
            '교통비': tot_sales02,   
          });  
          break;
        }
        case '100003': {
          datas.push({
            ...newItem,
            '설계비': tot_sales03,   
          });  
          break;
        }
        case '100004': {
          datas.push({
            ...newItem,
            '운영비': tot_sales04,   
          });  
          break;
        }
        case '100005': {
          datas.push({
            ...newItem,
            'HSG진단': tot_sales05,   
          });                   
          break;
        }
        case '100006': {
          datas.push({
            ...newItem,
            'HSG컨설팅': tot_sales06,    
          });  
          break;
        }
        case '100007': {
          datas.push({
            ...newItem,
            '스튜디오비': tot_sales07,  
          });              
          break;
        }
        case '100008': {
          datas.push({
            ...newItem,
            '기타비': tot_sales08,   
          });       
          break;
        }
        case '199999': {
          datas.push({
            ...newItem,
            '교재비': tot_sales01,   
            '교통비': tot_sales02,   
            '설계비': tot_sales03,   
            '운영비': tot_sales04,   
            'HSG진단': tot_sales05,   
            'HSG컨설팅': tot_sales06,   
            '스튜디오비': tot_sales07,   
            '기타비': tot_sales08,  
            '누계': tot_sales09,   
          });  
          break;
        }   
        case '300000': {
          datas.push({
            ...newItem,
            '강의시간': tot_time,
            '강사매출': tot_sales,      
            '교재비': tot_sales01,   
            '교통비': tot_sales02,   
            '설계비': tot_sales03,   
            '운영비': tot_sales04,   
            'HSG진단': tot_sales05,   
            'HSG컨설팅': tot_sales06,   
            '스튜디오비': tot_sales07,   
            '기타비': tot_sales08,   
            '매출': tot_sales10,   
          });              
          break;
        }                                                                       
        default : {
          datas.push({
            ...newItem,
            '강의시간': tot_time,
            '강사매출': tot_sales,               
          });              
          break;          
        }
      }      
    }
    merges.push({s: {c:0, r:datas.length}, e: {c:mergeCnt-1, r:datas.length}});

    const book = XLSX.utils.book_new();
    const nurses = XLSX.utils.json_to_sheet(
      datas, 
      { 
        header : header, 
        skipHeader : false 
      } 
    );

    nurses["!cols"] = [
      { wpx : 100 } 
    , { wpx : 150 } 
    , { wpx : 200 }  
    , { wpx : 150 }  
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    , { wpx : 150 } 
    ]
    if (merges.length > 0) {
      nurses["!merges"]  = merges;   
    }

    XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
    XLSX.writeFile( book, year+'_'+startMonth +'월_'+endMonth+'월_강의평가.xlsx'); 
  }  

  /* ======================================================
  * hooks
  * ====================================================== */

  useEffect(() => {
    if (!!hiddenColumns) {
      const newColumns = columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0);
      setViewColumns(newColumns);

      let cnt = newColumns.length;
      if (hiddenColumns.findIndex((col)=>col === 'lecturer_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'time_count') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'class5') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'class7') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'class10') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'nps') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'teaching_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'traffic_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'plan_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'operating_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'diagnose_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'consulting_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'studio_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'etc_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'order_price') < 0) {cnt--;}
      if (hiddenColumns.findIndex((col)=>col === 'max_price') < 0) {cnt--;}
      setMergeCnt(cnt);
    }

  }, [hiddenColumns, salesList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{width:'100%', justifyContent:'space-between', marginTop:'20px'}}>
        <Space>
          <Select 
            value={startMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(value, endMonth)}}
            style={{width: '80px'}}
          /> 
          <Select 
            value={endMonth}
            options={months}
            onSelect={(value)=>{onChangeDetailMonth(startMonth, value)}}
            style={{width: '80px'}}
          />       
        </Space>
        <Space>
          <Button icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
        </Space>            
      </Space>      
      <TableWrapper isSearch={false}>
        <Table
          tableLayout="fixed"
          dataSource={salesList}
          columns={viewColumns}
          pagination={false}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
          rowClassName={(record) => (record.err > 0 ? 'row-err' : '')}
          summary={pageData => {
            let totalLecturerPrice = 0;
            let totalTeachingPrice = 0;
            let totalTrafficPrice = 0;
            let totalPlanPrice = 0;
            let totalOperatingPrice = 0;
            let totalDiagnosePrice = 0;
            let totalConsultingPrice = 0;
            let totalStudioPrice = 0;
            let totalEtcPrice = 0;
            let totalOrderPrice = 0;
            let totalMaxPrice = 0;
            let totalTime = 0;
            let totalnps = 0;
            let totalclass5 = 0;
            let totalclass7 = 0;
            let totalclass10 = 0;
            let totalnpsCnt = 0;
            let totalclass5Cnt = 0;
            let totalclass7Cnt = 0;
            let totalclass10Cnt = 0;

            pageData.forEach((item) => {
              if (item.type === 'info') {
                totalLecturerPrice += item.lecturer_price;
                totalTeachingPrice += item.teaching_price;
                totalTrafficPrice += item.traffic_price;
                totalPlanPrice += item.plan_price;
                totalOperatingPrice += item.operating_price;
                totalDiagnosePrice += item.diagnose_price;
                totalConsultingPrice += item.consulting_price;
                totalStudioPrice += item.studio_price;
                totalEtcPrice += item.etc_price;
                totalOrderPrice += item.order_price;
                totalMaxPrice += item.max_price;
                totalTime += item.time_count;
                if (item.nps > 0) {
                  totalnps += item.nps;
                  totalnpsCnt++;
                }
                if (item.class5 > 0) {
                  totalclass5 += item.class5;
                  totalclass5Cnt++;
                }
                if (item.class7 > 0) {
                  totalclass7 += item.class7;
                  totalclass7Cnt++;
                }
                if (item.class10 > 0) {
                  totalclass10 += item.class10;
                  totalclass10Cnt++;
                }
              }
            });

            return (
              <Table.Summary.Row style={{backgroundColor:'#f7f7f7', fontWeight:'500', color:'red'}}>
                <Table.Summary.Cell colSpan={mergeCnt} index={0} align='center'>합계</Table.Summary.Cell>
                {(hiddenColumns.findIndex((col)=>col === 'time_count') < 0) && (<Table.Summary.Cell  index={6} align='center'>{totalTime.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'lecturer_price') < 0) && (<Table.Summary.Cell  index={7} align='right'>{totalLecturerPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}                
                {(hiddenColumns.findIndex((col)=>col === 'teaching_price') < 0) && (<Table.Summary.Cell  index={8} align='right'>{totalTeachingPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'traffic_price') < 0) && (<Table.Summary.Cell  index={9} align='right'>{totalTrafficPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'plan_price') < 0) && (<Table.Summary.Cell  index={10} align='right'>{totalPlanPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'operating_price') < 0) && (<Table.Summary.Cell  index={11} align='right'>{totalOperatingPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'diagnose_price') < 0) && (<Table.Summary.Cell  index={12} align='right'>{totalDiagnosePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'consulting_price') < 0) && (<Table.Summary.Cell  index={13} align='right'>{totalConsultingPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'studio_price') < 0) && (<Table.Summary.Cell  index={14} align='right'>{totalStudioPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'etc_price') < 0) && (<Table.Summary.Cell  index={15} align='right'>{totalEtcPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'order_price') < 0) && (<Table.Summary.Cell  index={16} align='right'>{totalOrderPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'max_price') < 0) && (<Table.Summary.Cell  index={17} align='right'>{totalMaxPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'class5') < 0) && (<Table.Summary.Cell  index={18} align='center'>{(totalclass5Cnt>0)?(totalclass5/totalclass5Cnt).toFixed(2):''}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'class7') < 0) && (<Table.Summary.Cell  index={19} align='center'>{(totalclass7Cnt>0)?(totalclass7/totalclass7Cnt).toFixed(2):''}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'class10') < 0) && (<Table.Summary.Cell  index={20} align='center'>{(totalclass10Cnt>0)?(totalclass10/totalclass10Cnt).toFixed(2):''}</Table.Summary.Cell>)}
                {(hiddenColumns.findIndex((col)=>col === 'nps') < 0) && (<Table.Summary.Cell  index={21} align='center'>{(totalnpsCnt>0)?(totalnps/totalnpsCnt).toFixed(2):''}</Table.Summary.Cell>)}
              </Table.Summary.Row>
            );
          }}
        />
      </TableWrapper>  
    </Space>
  );
};

export default SALESTable;
